import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import BackgroundGradient from "../../Images/BackgroundGradient.png";
import BackgroundGradientSmall from "../../Images/BackgroundGradientSmall.png";
import TitleContent from "../../Components/TitleContent";
import { KeyFeatures } from "../../Components/KeyFeatures";
import QUANTUMREPEATER from "../../Images/Boxes/QUANTUMREPEATER_P1.png";

export default function QuantumRepeater() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener("resize", updateBackgroundImage);

    return () => window.removeEventListener("resize", updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const keyFeatures = [
   "Entanglement Generation - Produce entangled photon pairs over short segments using sources like SPDC. ", 
"Quantum Memories - Store quantum states in our own atomic Quantum Memory to synchronize operations. ", 
"Entanglement Swapping - Perform Bell-state measurements at intermediate nodes to extend entanglement chain-wise. ", 
"Purification & Error Correction - Distill cleaner entanglement from noisy pairs and manage errors for high fidelity. This heralded, divide-and-conquer approach exponentially boosts range compared to direct links.",



   "Cryogen-free / room-temperature compatible options for practical deployment",  
"Telecom-wavelength operation — minimal loss in existing fiber networks ", 
"Modular & scalable — from metro to intercontinental scales  ",
"High-fidelity entanglement — supports practical rates for real-world use  ",
"Compact nodes — easier integration than bulky alternatives  ",


    "Unbreakable Quantum Key Distribution (QKD) — Secure communication over global distances for finance, defense, and data centers  ",
"Distributed Quantum Computing — Connect remote quantum processors for massive computational power  ",
"Quantum Sensor Networks — Ultra-precise synchronized sensing for navigation, gravity mapping, and biomedicine  ",
"Quantum Internet Backbone — Foundation for entanglement-based secure networks and advanced AI  ",


  ];

  

  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />
        <div className="w-full h-[25rem] ">
          <ProductsHeroSection
            title1="Bridging Distances"
            title2="for the Quantum Internet"
            content="High-performance quantum repeater systems enabling long-distance entanglement distribution by overcoming photon loss and decoherence. Designed for scalable, secure quantum communication across fiber networks, supporting next-generation quantum internet infrastructure. "
            scrollToArchitecture={scrollToArchitecture}
          />
        </div>

        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">
              Quantum Repeater: Enabling the Quantum Internet
            </span>
          </div>

          <div className="w-[90%] h-full   grid grid-cols-1 xl:grid-cols-2  place-items-start  p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                At QAIG, we are developing state-of-the-art Quantum Repeaters —
                the critical technology to overcome distance limitations in
                quantum communication and realize a secure, global Quantum
                Internet.
              </div>
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                Quantum states and entanglement cannot be copied (no-cloning
                theorem), and photons suffer exponential loss and decoherence in
                optical fibers, restricting direct transmission to ~100–200 km.
                Our quantum repeaters break this barrier by segmenting long
                distances into shorter links, reliably distributing
                high-fidelity entanglement over thousands of kilometers
              </div>

              <div className="w-full px-3 flex items-start justify-start">
                <KeyFeatures
                  title="Core Working Principle"
                  features={keyFeatures.slice(0, 4)}
                />
              </div>
            </div>

            <div className="w-full  flex flex-col items-start justify-start  gap-1">
              <KeyFeatures
                title="Innovation"
                features={keyFeatures.slice(5, 9)}
              />

              <KeyFeatures
                title="Game-Changing Applications"
                features={keyFeatures.slice(9, 13)}
              />
            </div>
          </div>
          {/* <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start  ">
            <KeyFeatures
              title="Key Advantages"
              features={keyFeatures.slice(5, 9)}
            />

            <KeyFeatures
              title="Game-Changing Applications"
              features={keyFeatures.slice(22, 29)}
            />
          </div> */}
          <div className="w-[90%] h-full flex flex-col md:flex-row justify-center items-center gap-10 my-10">
            <div className="w-full flex flex-col items-center justify-center">
              <img
                className="w-[21.5rem]   md:w-[600px]  object-contain rounded-lg md:rounded-2xl"
                src={QUANTUMREPEATER}
              ></img>
              <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 mt-2">
                Figure 1: Schematic of a quantum repeater setup showing
                entanglement distribution via quantum memories, photon sources,
                and Bell-state measurements across segments.( Figueroa Research
                Group)
              </p>
            </div>
          </div>
          <TitleContent
            title="Our Advancement"
            content="QAIG has demonstrated the first Made In India Quantum Memory using room temperature Rubidium vapours, and an Entangled Photon Source (EPS) two of the  essential repeater components in lab settings and is progressing toward next phase. We are currently focussing on integrating on quantum memories, efficient photon sources, and swapping modules  targeting deployment in national and commercial quantum networks. "
            scrollToArchitecture={scrollToArchitecture}
          />
          <p className="w-full text-center font-bold  text-xs md:text-sm text-[#1B99D4] mt-2">
            Entanglement delivered — anywhere, anytime.
          </p>
        </div>

        {/* <VideoComponent
          image={QSleeveImage}
          video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
        /> */}
        <div
          className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>

        <ProductFooter />
      </div>
    </div>
  );
}
